import styled from '@emotion/styled';
import { zIndex, space } from 'styled-system';
import { withProps } from 'recompose';
import { buttonStyles } from '../../stories/new-story-popup/styled';

export const ButtonBar = styled.div`
  ${props => props.theme.utils.flexCentre()};
  height: 60px;
  position: relative;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;

  &::before,
  &::after {
  content: '';
  border-top: 1px solid #64748B;
  opacity:0.3;
  flex-grow: 1;
  margin: 0 10px;
  }

  @media screen and (max-width: 600px) {
    max-width: 100%;
  }
`;

export const Button = withProps({ type: 'button' })(styled.button`
  ${props => props.theme.utils.flexCentre()};
  ${buttonStyles};
display: flex;
justify-content:center;
align-items:center;

  color: ${props => props.theme.colors.brand};
  height: 24px;
  width: 24px;
  border: 2px solid #9B59B6;
  background: ${props => props.theme.colors.white};
  margin: 0 calc(${props => props.theme.gutter} / 2);
  cursor: pointer;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
padding: 4px;
  position: relative;
  ${zIndex};
  ${space};

  svg {
    margin: auto;
  }
`);
